import { Pipe, PipeTransform } from '@angular/core';
import { FormatHelper } from 'src/app/api/helper/format-helper';

/**
 * EP = Einzelpreis
 */
@Pipe({
    name: 'ep',
    standalone: false
})
export class EPPipe implements PipeTransform {
    transform(value: number, args: string[] = []): any {
        if (!value) {
            return value;
        };

        return FormatHelper.formatEP(value);
    }
}
